export const unitLabels = { UNIT: 'un', MILLILITER: 'ml', GRAM: 'g' } as const;
